module.exports = __webpack_public_path__ + "no-polls-background-610bfdb206ee179ed2056e3662168407.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/no-polls-background.png
// module id = 1776
// module chunks = 1